import React from 'react';
import type { TooltipProps } from 'antd';

import { modalForceStyles, SvgTrigger, Tooltip } from './styled.ts';

type BaseTooltipProps = TooltipProps & {
    icon?: React.ReactElement;
};

export const BaseTooltip: React.FC<BaseTooltipProps> = ({ className, icon, children, ...props }) => (
    <Tooltip
        className={className}
        {...props}
        styles={{
            container: modalForceStyles.TooltipContainer,
        }}
    >
        {icon ? <SvgTrigger>{icon}</SvgTrigger> : children}
    </Tooltip>
);
